
const digest = '5d46e4d336c4acaafd824ae19d75236695d88f72b1cfc18ceb35df9e6fa8c452';
const classes = {"items":"_items_1puxe_1","smallerText":"_smallerText_1puxe_6","address":"_address_1puxe_9","extraInfo":"_extraInfo_1puxe_13"};
const css = `._items_1puxe_1 {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
._items_1puxe_1 ._smallerText_1puxe_6 {
  font-size: 12px;
}
._items_1puxe_1 ._address_1puxe_9 {
  font-size: 14px;
  font-weight: 500;
}
._items_1puxe_1 ._extraInfo_1puxe_13 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  